import {
  CONSENT_COOKIE,
  CONSENT_FUNCTIONAL,
  CONSENT_SESSION,
  GOOGLE_ID_SIMPLIFIED,
  JUPITER_TOKEN,
} from "./constants";
import { getCookie, hasCookie, removeCookie, setCookie } from "./utils";

const expiry = 365 * 24 * 60 * 60; // 1 year

export const checkLongLifeConsentCookie = () => {
  if (hasCookie(CONSENT_COOKIE)) {
    if (getCookie(CONSENT_COOKIE) !== null) {
      return true;
    } else {
      return false;
    }
  }
  return false;
};

export const setLongLifeConsentCookie = () => {
  if (hasCookie(CONSENT_COOKIE)) removeCookie(CONSENT_COOKIE);
  setCookie(CONSENT_COOKIE, "consent", expiry, "/");
};

export const checkFunctionalCookiesAllowed = () => {
  if (hasCookie(CONSENT_FUNCTIONAL)) {
    if (getCookie(CONSENT_FUNCTIONAL) !== null) {
      return true;
    } else {
      return false;
    }
  }
  return false;
};

export const setFunctionalCookiesAllowed = () => {
  if (hasCookie(CONSENT_FUNCTIONAL)) removeCookie(CONSENT_FUNCTIONAL);
  setCookie(CONSENT_FUNCTIONAL, "consent_functional", expiry, "/");
};

export const removeFunctionalCookiesAllowedCookie = () => {
  if (hasCookie(CONSENT_FUNCTIONAL)) removeCookie(CONSENT_FUNCTIONAL);

  // -- remove all functional cookies --
  removeCookie("_ga");
  removeCookie("_gid");
  removeCookie("_gat");
  removeCookie(`_ga_${GOOGLE_ID_SIMPLIFIED}`);
  removeCookie("APISID");
  removeCookie("HSID");
  removeCookie("SSID");
  removeCookie("SID");
  removeCookie("SAPISID");
  removeCookie("IDE");
  removeCookie("NID");
  removeCookie("__Secure-1PAPISID");
  removeCookie("__Secure-1PSID");
  removeCookie("__Secure-3PSID");
  removeCookie("__Secure-3PAPISID");
  removeCookie("__gfp_s_64b");
  removeCookie("ar_debug");
  removeCookie("ajs_anonymous_id");
};

export const setSessionConsentCookie = () => {
  if (hasCookie(CONSENT_SESSION)) removeCookie(CONSENT_SESSION);
  setCookie(CONSENT_SESSION, "consent_session");
};

export const checkSessionCookie = () => {
  if (hasCookie(CONSENT_SESSION)) {
    if (getCookie(CONSENT_SESSION) !== null) {
      return true;
    } else {
      return false;
    }
  }
  return false;
};

export const removeAllConsentCookies = () => {
  if (hasCookie(CONSENT_COOKIE)) removeCookie(CONSENT_COOKIE);
  if (hasCookie(CONSENT_FUNCTIONAL)) removeCookie(CONSENT_FUNCTIONAL);
  if (hasCookie(CONSENT_SESSION)) removeCookie(CONSENT_SESSION);
};

export const checkJupiterToken = () => {
  if (hasCookie(JUPITER_TOKEN)) {
    if (getCookie(JUPITER_TOKEN) !== null) {
      return true;
    } else {
      return false;
    }
  }
  return false;
};

export const getJupiterToken = () => {
  if (hasCookie(JUPITER_TOKEN)) {
    return getCookie(JUPITER_TOKEN);
  } else {
    return null;
  }
};

export const setJupiterToken = (token) => {
  const jupiterExpiry = 90 * 24 * 60 * 60; // 90 days
  if (hasCookie(JUPITER_TOKEN)) removeCookie(JUPITER_TOKEN);
  setCookie(JUPITER_TOKEN, token, jupiterExpiry, "/");
};

export const removeJupiterToken = () => {
  if (hasCookie(JUPITER_TOKEN)) removeCookie(JUPITER_TOKEN);
};
